module.exports = __webpack_public_path__ + "img/bannerSecundary.dac660e7.png";